import React, { useEffect, useRef } from 'react';

const GenericScrollToTop = () => {
  const buttonRef = useRef();

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  const checkPosition = () => {
    if (buttonRef.current) {
      window.scrollY > 350
        ? buttonRef.current.classList.add('scroll-to-top--show')
        : buttonRef.current.classList.remove('scroll-to-top--show');
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', checkPosition);
    return () => {
      window.removeEventListener('scroll', checkPosition);
    };
  }, []);

  return (
    <button className="scroll-to-top" onClick={scrollToTop} ref={buttonRef} aria-label="Scroll to top">
      <svg xmlns="http://www.w3.org/2000/svg" width="23" height="15" viewBox="0 0 23 15" fill="none">
        <path
          d="M3.51001 11.73L11.5 3.73999L19.49 11.73"
          stroke="#7D5D84"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};

export default GenericScrollToTop;
